import React, { useState } from "react";

function makeReadableName(path) {
  if (!path) return "";
  let name = decodeURIComponent(path.split("/").pop());
  name = name.replace(/-\d+\.(pdf|docx|txt|csv|png|jpe?g|gif|webp)$/i, ".$1");
  name = name.replace(/(\.[a-z0-9]+)\1$/i, "$1");
  name = name.replace(/[_-]+/g, " ");
  name = name.charAt(0).toUpperCase() + name.slice(1);
  return name;
}

async function downloadDoc(url, fileName) {
  try {
    const res = await fetch(url, { mode: "cors" });
    if (!res.ok) throw new Error("fetch failed");
    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = fileName || "document";
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(objectUrl);
  } catch (_) {
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName || "document";
    link.rel = "noopener";
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
}

function ChangeDateConfirmationRelevantFiles({ data }) {
  const [busyUrl, setBusyUrl] = useState("");
  const docs = Array.isArray(data?.relatedDocs) ? data.relatedDocs : [];

  if (!docs.length) return null;

  return (
    <div className="w-full bg-white rounded-xl border border-gray-200 p-5 mt-4">
      <span className="block font-semibold text-gray-900 text-base mb-2">
        Uploaded Files
      </span>
      <div className="flex flex-col gap-2">
        {docs.map((doc, docIndex) => {
          const url = typeof doc === "string" ? doc : doc?.url;
          const name = makeReadableName(url);
          if (!url) return null;
          return (
            <div
              key={docIndex}
              className="flex items-center justify-between gap-3"
            >
              <span className="text-sm text-gray-800 truncate">{name}</span>
              <button
                type="button"
                disabled={busyUrl === url}
                className="text-primary1 hover:underline font-medium text-sm disabled:opacity-50"
                onClick={async () => {
                  setBusyUrl(url);
                  await downloadDoc(url, name).finally(() => setBusyUrl(""));
                }}
              >
                {busyUrl === url ? "…" : "Download"}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ChangeDateConfirmationRelevantFiles;
